import type { FaireThemeEntity } from "../../entity_types/theme";

export const under_20_add_on_wins: FaireThemeEntity = {
  token: "under-20-add-on-wins",
  type: "theme",
  retailerToken: "r_rk3595bqqg",
  name: "Under-$20 Add\u2011On Wins",
  description: "Easy add-ons that boost average order value",
  bgColor: "#F5D6D6",
  tileBgColor: "#6d7a23",
  productTokens: [
    "p_z2fcxwbjvv",
    "p_tt2ey5tumn",
    "p_awkbgvry7b",
    "p_84aknwkcbz",
    "p_63ee10x8ey",
    "p_cufdf4884q",
    "p_jtaqbpkzq2",
    "p_952m9qh505",
    "p_karzbrz5h7",
    "p_7t4m4ggna5",
    "p_htwj676bsm",
    "p_ac7nh5eym2",
    "p_prd8xkh7ky",
    "p_2xed6tt75w",
    "p_2w45azs6ge",
    "p_ff9whq8b2u",
    "p_8jst837ndy",
    "p_pgdtd2464j",
    "p_trm9t5dshf",
    "p_4ux9ddf2zv",
  ],
  exactProducts: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:50:10Z",
    importedBy: "retailer-themes-entity-migration",
  },
};
